import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

type DataType = {
  roomId: string | string[]
  test_mode?: string
}

class SetLiveRoomOffApi extends Service {
  constructor({ roomId, ...restParams }: DataType) {
    super()
    this.name = 'SET_LIVE_ROOM_OFF'

    this.config = {
      url: `/v1/room/live/${roomId}`,
      method: 'DELETE',
      params: restParams,
    }
  }
}

export const setLiveRoomOff = (data: DataType) => getCallApiFunction(new SetLiveRoomOffApi(data))
